import { render, staticRenderFns } from "./PrkAvatar.vue?vue&type=template&id=00d688b1&scoped=true&"
import script from "./PrkAvatar.vue?vue&type=script&lang=js&"
export * from "./PrkAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PrkAvatar.vue?vue&type=style&index=0&id=00d688b1&scoped=true&lang=scss&"
import style1 from "./PrkAvatar.vue?vue&type=style&index=1&id=00d688b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d688b1",
  null
  
)

export default component.exports